/*
 * Components rather than the PNGs these used to be. The sidebar turned from a
 * dark panel into a light one, and the old icons were white 512px images: on
 * the new ground they would be invisible, and being raster there is no way to
 * recolour them. These take their colour from the row they sit in.
 */
import EmployeesIcon from "../assets/icons/nav/EmployeesIcon";
import BotsIcon from "../assets/icons/nav/BotsIcon";
import StatisticsIcon from "../assets/icons/nav/StatisticsIcon";
import HistoryIcon from "../assets/icons/nav/HistoryIcon";
import config from "../config";

export const subMenuManagement = [
    {
        index: 2,
        id: 'sidebar-link-management-members',
        path: '/dashboard/management/members',
        name: 'Members',
        alt: 'management_members',
        icon: EmployeesIcon,
        permissions: [config.rolesMap.owner, config.rolesMap.admin],
        translateKey: "members",
        features: [config.features.USER_MANAGEMENT],
        styleName: "subMenuItem"
    },
    {
        index: 3,
        id: 'sidebar-link-management-clients',
        path: '/dashboard/management/clients',
        name: 'Bots',
        alt: 'management_clients',
        icon: BotsIcon,
        permissions: [config.rolesMap.owner, config.rolesMap.admin],
        translateKey: "Bots",
        styleName: "subMenuItem"
    },
    {
        index: 5,
        id: 'sidebar-link-management-statistics',
        path: '/dashboard/management/statistics',
        name: 'Statistics',
        alt: 'management_statistics',
        icon: StatisticsIcon,
        permissions: [config.rolesMap.owner, config.rolesMap.admin],
        translateKey: "statistics",
        features: [config.features.STATISTICS],
        styleName: "subMenuItem"
    },
    {
        index: 6,
        id: 'sidebar-link-management-history',
        path: '/dashboard/management/history',
        name: 'History',
        alt: 'management_history',
        icon: HistoryIcon,
        permissions: [config.rolesMap.owner, config.rolesMap.admin],
        translateKey: "history",
        features: [config.features.HISTORY],
        styleName: "subMenuItem"
    },
]


// WEBPACK FOOTER //
// ./src/utils/Constans.js